const COMPARISION_KEY = 'b2b-offer';
const OFFER_PARAMS = 'b2b-offer-params';

export default {

  saveParams(markupType,markupValue) {
    let obj = {markupType: markupType, markupValue: markupValue};
    window.localStorage.setItem(OFFER_PARAMS, JSON.stringify(obj));
  },

  loadParam(property) {
    let code = window.localStorage.getItem(OFFER_PARAMS);
    if (code) {
      let obj = JSON.parse(code);
      return obj != null && obj[property] != undefined ? obj[property] : null;
    }
    return null;
  },


  addProduct(productId, variantId, quantity, setPrice) {
    let products = this.getProducts();
    let product = products.find(p => p.id == productId);
    if (product == null) {
      products.push({id: productId, variant: variantId, quantity: quantity, setPrice: setPrice});
    } else {
      product.quantity = quantity;
      product.setPrice = setPrice;
    }
    window.localStorage.setItem(COMPARISION_KEY, JSON.stringify(products));
  },

  removeProduct(variantId) {
    let products = this.getProducts();
    var index = products.map(p => p.variant).indexOf(variantId);
    if (index > -1) {
      products.splice(index, 1);
      window.localStorage.setItem(COMPARISION_KEY, JSON.stringify(products));
    }
  },



  getProducts() {
    let code = window.localStorage.getItem(COMPARISION_KEY);
    if (code) {
      return JSON.parse(code);
    }
    return [];
  },

  clear() {
    window.localStorage.removeItem(COMPARISION_KEY);
  }
}



// WEBPACK FOOTER //
// ./src/components/offer/src/OfferStorage.js